import { queryTask, queryMode, IdentifyTaskAsync } from "../../utils/querying/gis-data";
/**
 * @category data manipulations
 * @example
 * ```typescript
 * let options = {
 * url: ''
 * }
 * let data = await momraGisCore.getFeatures(options);
 * ```
 */
export function getFeatures(options) {
    return queryTask({
        url: options.url,
        returnGeometry: options.returnGeometry,
        outFields: options.outFields,
        where: options.where,
        mode: queryMode.Features,
        geometry: options.geometry,
        spatialRelationship: options.spatialRelationship,
        num: options.num,
        start: options.start,
        returnDistinctValues: options.returnDistinctValues,
        objectIds: options.objectIds,
        orderByFields: options.orderByFields,
        distance: options.distance,
        units: options.units
    });
}
/**
 * @category data manipulations
 * @example
 * ```typescript
 *
 */
export function getFeaturesCount(options) {
    return queryTask({
        url: options.url,
        returnGeometry: options.returnGeometry,
        outFields: options.outFields,
        where: options.where,
        mode: queryMode.FeatureCount,
        geometry: options.geometry,
        spatialRelationship: options.spatialRelationship,
        num: options.num,
        start: options.start,
        returnDistinctValues: options.returnDistinctValues,
        objectIds: options.objectIds,
        orderByFields: options.orderByFields,
        distance: options.distance,
        units: options.units
    });
}
/**
 * @category data manipulations
 * @example
 * ```typescript
 * let identifySettings = {
                url: '',
                tolerance: 100,
                layerIds: [1,2,3],   //array of layers ids
                layerOption: 'top',  //"top"|"visible"|"all"
                geometry: geometry,
                returnGeometry: true,
                mapView: mapView
            }
            let identifyData = await momraGisCore.identifyTask(identifySettings);
 * ```
            @version 1.0.2
 */
export function identifyTask(settings) {
    return IdentifyTaskAsync(settings).then(respones => {
        return respones;
    });
}
